// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { MatterTemplate } from "../../types";

const matterTemplatesModule = {
  async findByUserId(userId: string): Promise<MatterTemplate[]> {
    const result = await sql`
      SELECT * FROM matter_templates
      WHERE user_id = ${userId} OR is_system = true
      ORDER BY is_system DESC, position ASC, created_at DESC
    `;
    return (result || []) as MatterTemplate[];
  },

  async create(data: Omit<MatterTemplate, 'id' | 'created_at' | 'updated_at'>): Promise<MatterTemplate> {
    const result = await sql`
      INSERT INTO matter_templates (user_id, title, description, is_system, position)
      VALUES (${data.user_id}, ${data.title}, ${data.description}, ${data.is_system}, ${data.position})
      RETURNING *
    `;
    return result[0] as MatterTemplate;
  },

  async update(id: string, userId: string, data: Partial<MatterTemplate>): Promise<MatterTemplate> {
    const result = await sql`
      UPDATE matter_templates
      SET title = COALESCE(${data.title}, title),
          description = COALESCE(${data.description}, description),
          position = COALESCE(${data.position}, position),
          updated_at = now()
      WHERE id = ${id} AND user_id = ${userId}
      RETURNING *
    `;
    return result[0] as MatterTemplate;
  },

  async delete(id: string, userId: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM matter_templates
      WHERE id = ${id} AND user_id = ${userId} AND is_system = false
    `;
    return result.count > 0;
  }
};

export type MatterTemplatesModule = typeof matterTemplatesModule;

export function registerMatterTemplates(db: { matterTemplates?: MatterTemplatesModule }) {
  db.matterTemplates = matterTemplatesModule;
}

export { matterTemplatesModule as matterTemplates };
